"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./TooltipIcon.css");
var Popover_1 = require("../../components/Popover");
var MDIcon_1 = require("../../components/MDIcon");
var classnames_1 = __importDefault(require("classnames"));
var useDomEvent_1 = require("../../hooks/useDomEvent");
var TooltipIcon = function (_a) {
  var icon = _a.icon,
    _b = _a.iconColor,
    iconColor = _b === void 0 ? "info" : _b,
    _c = _a.iconSize,
    iconSize = _c === void 0 ? "1.3em" : _c,
    _d = _a.interactive,
    interactive = _d === void 0 ? true : _d,
    iconRotation = _a.iconRotation,
    iconFlip = _a.iconFlip,
    iconClassName = _a.iconClassName,
    _e = _a.active,
    active = _e === void 0 ? false : _e,
    wrapperProps = _a.wrapperProps,
    setActive = _a.setActive,
    restProps = __rest(_a, ["icon", "iconColor", "iconSize", "interactive", "iconRotation", "iconFlip", "iconClassName", "active", "wrapperProps", "setActive"]);
  var iconRef = (0, react_1.useRef)(null);
  var wrapperRef = (0, react_1.useRef)(null);
  (0, useDomEvent_1.useOutsideEvent)("click", iconRef, function (e) {
    var _a;
    if (!interactive) setActive(false);
    if ((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
      return;
    }
    setActive(false);
  });
  return (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({}, restProps, {
    shown: active,
    interactive: interactive,
    wrapperProps: __assign(__assign({}, wrapperProps), {
      className: (0, classnames_1.default)("vsx-tooltip-icon", wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className),
      ref: wrapperRef
    })
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      refObject: iconRef,
      size: iconSize,
      icon: icon,
      color: iconColorMap[iconColor],
      cursor: "pointer",
      rotation: iconRotation,
      flip: iconFlip,
      className: (0, classnames_1.default)("vsx-tooltip-mdicon", active && "active", iconClassName),
      onClick: function (e) {
        setActive(R.not);
        e.stopPropagation();
      }
    })
  }));
};
exports.TooltipIcon = TooltipIcon;
var iconColorMap = {
  "success": "var(--color-background-button-primary-default)",
  "info": "var(--color-icon-default)",
  "warning": "var(--color-icon-critical)"
};